export default __webpack_public_path__ + "static/media/nextArrowMob.17bfb711.svg";